<template>
    <div class="table-list-wrapper"
         :style="{position: positionAbsolute ? 'absolute':''}"
         v-loading="loading" element-loading-background="rgba(255, 255, 255, 0.12)">
        <div class="table-list__header">
            <el-input class="table-list-search input-height"
                      v-if="searchShow"
                      placeholder="搜索问题"
                      suffix-icon="el-icon-search"
                      clearable
                      @blur="toSearchKey"
                      @clear="clearSearch"
                      @keyup.enter.native="toBlur($event)"
                      v-model.trim="mySearchKey"/>
        </div>
        <div class="table-list">
            <el-table v-if="tableData.length" :data="tableData"
                      ref="tableList"
                      key="qaTable"
                      height="100%">
                <template v-for="item in tableFiled">
                    <el-table-column :key="item.code" :prop="item.code"
                                     :label="item.label" :width="item.width" :align="item.align">
                        <template slot-scope="scope">
                            <span>{{scope.row[item.code]}}</span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="table-list__total">记录数：{{tableData.length}}</div>
    </div>
</template>

<script>
import AppDialog from '../AppDialog';
export default {
    name: 'qa-table',
    components: { AppDialog },
    props: {
        // 是否展示搜索框
        searchShow: {
            type: Boolean,
            default: true
        },
        // 是否需要发送接口请求List
        needGetList: {
            type: Boolean,
            default: true
        },
        qaList: {
            type: Array,
            default: null
        },
        qaHeaderList: {
            type: Array,
            default: null
        },
        needFormatHeader: {
            type: Boolean,
            default: true
        },
        documentInfo: {
            type: Object,
            default: () => {
                return {};
            }
        },
        positionAbsolute: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            loading: false,
            qaRepeatStatus: false,
            qaRepeatUrl: '',
            showWarningFileTips: false,
            tableData: [],
            tableFiled: [],
            myQaHeaderList: [],
            myQaList: [],
            mySearchKey: ''
        };
    },
    watch: {
        // 如果外部有传值，首次数据就用外部的
        qaHeaderList: {
            handler (val) {
                this.loading = true;
                if (val && val.length) {
                    this.myQaHeaderList = val;
                    this.myQaList = this.qaList;
                    this.init();
                } else {
                    if (this.needGetList) {
                        this.getList();
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        init () {
            let qaList = this.myQaList || [];
            if (qaList.length) {
                // 二次初始化表头
                if (this.needFormatHeader) {
                    let filedList = [];
                    for (let i = 0; i < this.myQaHeaderList.length; i++) {
                        filedList.push({
                            label: this.myQaHeaderList[i],
                            code: this.myQaHeaderList[i]
                        });
                    }
                    this.tableFiled = filedList;
                } else {
                    this.tableFiled = this.myQaHeaderList;
                }
                this.tableData = qaList;
                this.$nextTick(() => {
                    this.$refs.tableList && this.$refs.tableList.doLayout();
                    this.loading = false;
                });
            }
        },
        getList () {
            this.$api.knowledgeApi.getQaList({
                documentId: this.documentInfo.documentId,
                question: this.mySearchKey
            }).then((res) => {
                // 如果已初始化过表头，就直接渲染表数据
                if (this.myQaHeaderList.length) {
                    this.tableData = res.data.data.qaList || [];
                } else {
                    this.myQaList = res.data.data.qaList || [];
                    this.myQaHeaderList = res.data.data.qaHeaderList || [];
                    this.init();
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        clearSearch () {
            this.mySearchKey = '';
            this.$nextTick(() => {
                this.toSearchKey();
            });
        },
        toSearchKey () {
            this.getList();
        },
        toBlur ($event) {
            $event.target.blur();
        }
    }
};
</script>
<style lang="scss" scoped>
.table-list-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: var(--knowledge-right-bg);
    padding: 8px 0 0 16px;
    .table-list__total {
        padding-top: 16px;
        color: var(--knowledge-text);
    }
    .table-list__header {
        width: 100%;
        .table-list-btns {
            float: left;
            .import-icon {
                width: 14px;
                margin-top: -2px;
                margin-right: 6px;
            }
        }
        .table-list-search {
            width: 240px;
            float: right;
        }
    }
    .table-list {
        overflow-y: scroll;
    }
    ::v-deep {
        .el-table tr, .el-table, .el-table th.el-table__cell, .el-table__row {
            background-color: transparent;
            color: var(--knowledge-text);
        }
        td {
            background-color: transparent!important;
            border-bottom: 1px solid var(--border-color);
        }
        .el-input__inner {
            background-color: var(--knowledge-right-bg);
            color: var(--knowledge-text);
        }
    }
}
</style>
<style lang="scss">
.qaTableImportDialog, .qaTableEditDialog {
    .el-form-item {
        margin-bottom: 20px;
        .el-form-item__label {
            white-space: nowrap;
        }
        .el-form-item__content {
            width: 100%;
        }
    }
    .upload-btn {
        .button-height {
            img {
                width: 16px;
                vertical-align: sub;
                margin-right: 2px
            }
        }
    }
    .upload-btn_tips {
        color: rgba(0, 0, 0, 0.45);
        margin-left: 8px;
    }
    .el-upload__tip {
        color: rgba(0, 0, 0, 0.45);
        margin-top: -8px;
    }
}
.qaTableImportDialog {
    .app-dialog_content {
        position: relative;
        .warning-tips-wrapper {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 32px;
            background: rgba(255,3,3,0.1);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 16px;
            .down-icon, .waring-icon {
                width: 16px;
                margin-right: 8px;
                margin-top: -3px;
            }
        }
        .warningTipsClass {
            margin-top: 17px;
        }
    }
}
.qaTableEditDialog {
    .dialog-form {
        max-height: 280px;
        overflow-y: scroll;
        .el-form-item__label {
            width: 100px;
            max-width: 100px;
            white-space: normal!important;
            word-break: break-word;
            line-height: 1!important;
        }
    }
}
</style>
